module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/venue-da5b8b47683f8b55ef38788f68bfd9b6.png";